export default __webpack_public_path__ + "static/media/b15-thumb.da9ebf7d.jpg";